import { useLocale } from '../i18n'

function Header() {
  const { t } = useLocale()

  return (
    <header className="header">
      <h1>{t('header.title')}</h1>
      <p>{t('header.subtitle')}</p>
    </header>
  )
}

export default Header
